// extracted by mini-css-extract-plugin
export default {"RestaurantsMap__preloader":"RestaurantsMap_RestaurantsMap__preloader__1sj0N","RestaurantsMap__mapLayout":"RestaurantsMap_RestaurantsMap__mapLayout__2NuGw"};